export default function ElectricOven() {
    return (
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.6692 22.4064H5.33035C4.66729 22.4064 4.12988 21.8296 4.12988 21.118V2.5521C4.12988 1.84046 4.66729 1.26367 5.33035 1.26367H19.6692C20.3322 1.26367 20.8696 1.84046 20.8696 2.5521V21.118C20.8696 21.8296 20.3322 22.4064 19.6692 22.4064Z"
                stroke="#7293F7"
                strokeWidth="0.9"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M4.12988 6.12695H20.8696" stroke="#7293F7" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.8501 19.398H7.14992C6.70815 19.398 6.34961 19.0136 6.34961 18.539V11.2242C6.34961 10.7496 6.70815 10.3652 7.14992 10.3652H17.8501C18.2919 10.3652 18.6504 10.7496 18.6504 11.2242V18.539C18.6504 19.0136 18.2919 19.398 17.8501 19.398Z"
                stroke="#7293F7"
                strokeWidth="0.9"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.4863 4.30666H14.7755V2.98047H10.4863V4.30666Z"
                stroke="#7293F7"
                strokeWidth="0.9"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.55746 3.64494C8.55746 4.08086 8.2039 4.43442 7.76799 4.43442C7.33171 4.43442 6.97852 4.08086 6.97852 3.64494C6.97852 3.20903 7.33171 2.85547 7.76799 2.85547C8.2039 2.85547 8.55746 3.20903 8.55746 3.64494Z"
                stroke="#7293F7"
                strokeWidth="0.9"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.0223 3.64494C18.0223 4.08086 17.6687 4.43442 17.2328 4.43442C16.7966 4.43442 16.4434 4.08086 16.4434 3.64494C16.4434 3.20903 16.7966 2.85547 17.2328 2.85547C17.6687 2.85547 18.0223 3.20903 18.0223 3.64494Z"
                stroke="#7293F7"
                strokeWidth="0.9"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M6.33398 8.24414H18.6348" stroke="#7293F7" strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.34375 22.7374H7.63866V22.4062H6.34375V22.7374Z"
                stroke="#7293F7"
                strokeWidth="0.9"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.3613 22.7374H18.6562V22.4062H17.3613V22.7374Z"
                stroke="#7293F7"
                strokeWidth="0.9"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
